import React from 'react';

import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

import ProductCallout from '~/shared/components/ProductCallout';
import {
  useProductMarketingCallout,
  Callout,
} from '~/shared/utils/useProductCallout';

import { shouldShowCalloutOverlay } from '../../hooks/useProductCalloutOverlay';

const MarketingTagWrapper = styled.div`
  display: flex;
  padding: 5px 8px 6px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: absolute;
  left: 8px;
  top: 8px;
  border-radius: 64px;
  background: ${({ theme }) =>
    theme.colors.gridV2ProductCardImageBadgeBackground};
  box-shadow: 0 2px 10px 0
    ${({ theme }) => theme.colors.gridV2ProductCardImageBadgeBoxShadow};
  backdrop-filter: blur(5px);
  z-index: 1;
`;

const MarketingTagText = styled(ProductCallout)`
  color: ${({ $textColor }) => $textColor};
  leading-trim: both;
  text-edge: cap;
  font-family: ${({ theme }) => theme.fontStacks.standardGtPressuraFamily};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: ${10 / 12};
  text-transform: uppercase;
`;

const ProductCardImageBadge = ({ product }) => {
  const theme = useTheme();

  const callout = useProductMarketingCallout({
    product,
  });

  if (
    !product ||
    !callout ||
    !callout?.type ||
    shouldShowCalloutOverlay({ callout })
  ) {
    return null;
  }

  let textColor = theme.colors.gridV2ProductCardImageBadgeText;
  if (
    callout.type === Callout.YITTY ||
    callout.type === Callout.YITTY_COLLECTION
  ) {
    textColor = theme.colors.gridV2ProductCardImageBadgeTextYitty;
  }

  return (
    <MarketingTagWrapper>
      <MarketingTagText
        $textColor={textColor}
        type={callout.type}
        value={callout.value}
      />
    </MarketingTagWrapper>
  );
};

ProductCardImageBadge.propTypes = {
  product: PropTypes.object.isRequired,
};

export default ProductCardImageBadge;
